.stats {
  position: fixed;
  top: 3.5rem;
  left: 0;
  z-index: 999;
  pointer-events: none;
  font-family: monospace;
  font-size: 0.75rem;
  background-color: rgba(0, 0, 0, 0.8);
  color: #0ff;
  padding: 0.5rem;
  border-radius: 0.25rem;
}

.stats p {
  margin: 0;
}
